export default "__VITE_ASSET__XWpZN4dv__"